import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const EMPTY = { totals: {}, mixes: {}, tools: {}, fx: {}, milestones: [] };
const LiveCtx = createContext({ counts: EMPTY, refresh: () => {} });
const EVERY_MS = 5000;

export const LiveStatsProvider = ({ children }) => {
  const [counts, setCounts] = useState(EMPTY);

  const refresh = useCallback(() => {
    api.get("/counts")
      .then((r) => setCounts({
        totals: r.data?.totals ?? {}, mixes: r.data?.mixes ?? {}, tools: r.data?.tools ?? {}, fx: r.data?.fx ?? {},
        milestones: Array.isArray(r.data?.milestones) ? r.data.milestones : [],
      }))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(() => { if (!document.hidden) refresh(); }, EVERY_MS);
    const onVis = () => { if (!document.hidden) refresh(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVis); };
  }, [refresh]);

  return <LiveCtx.Provider value={{ counts, refresh }}>{children}</LiveCtx.Provider>;
};

export const useLiveStats = () => useContext(LiveCtx);
